"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisclosureAPI = void 0;
class DisclosureAPI {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    setToken(token) {
        this.token = token;
    }
    getHeaders() {
        const headers = {
            'Content-Type': 'application/json',
        };
        if (this.token) {
            headers['Authorization'] = `Bearer ${this.token}`;
        }
        return headers;
    }
    getDisclosures() {
        return __awaiter(this, arguments, void 0, function* (page = 1, limit = 10) {
            const response = yield fetch(`${this.baseUrl}/api/disclosures?page=${page}&limit=${limit}`, {
                headers: this.getHeaders(),
            });
            if (!response.ok)
                throw new Error('전자공고 목록 조회에 실패했습니다');
            return response.json();
        });
    }
    getDisclosureById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`${this.baseUrl}/api/disclosures/${id}`, {
                headers: this.getHeaders(),
            });
            if (!response.ok)
                throw new Error('전자공고 조회에 실패했습니다');
            return response.json();
        });
    }
}
exports.DisclosureAPI = DisclosureAPI;
